import { render, staticRenderFns } from "./IdelTimeIndicatorThresholdTable.vue?vue&type=template&id=3150e2a6&scoped=true&"
import script from "./IdelTimeIndicatorThresholdTable.vue?vue&type=script&lang=js&"
export * from "./IdelTimeIndicatorThresholdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3150e2a6",
  null
  
)

export default component.exports